import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
export function admins(state) {
  return state.admins;
}
export function adminsSelectOptions(state) {
  var admins = state.admins.map(function (admin) {
    return {
      value: admin.id,
      label: admin.name
    };
  });
  return [{
    value: null,
    label: '- no filter -'
  }, {
    value: 'not-assigned',
    label: '- not assigned -'
  }].concat(_toConsumableArray(admins));
}